import { render, staticRenderFns } from "./form-remove-from-group.vue?vue&type=template&id=a2daf1e8"
import script from "./form-remove-from-group.vue?vue&type=script&lang=js"
export * from "./form-remove-from-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports